/** 一次能贴完的上限。再多就先把范围收到一架或一层。 */
export const LOCATION_BATCH_LIMIT = 200;
/** 未选区域时，库位不超过这个数才把全部卡片画出来。 */
export const LOCATION_BROWSE_LIMIT = 100;
/** 生成、导入、批量改、删除空库位，一次最多这么多个。 */
export const LOCATION_MASTER_LIMIT = 2000;
const PAGE_WIDTH_MM = 210;
const PAGE_HEIGHT_MM = 297;
const LABEL_WIDTH_MM = 60;
const LABEL_HEIGHT_MM = 40;
const MARGIN_X_MM = 8;
const MARGIN_TOP_MM = 12;
const MARGIN_BOTTOM_MM = 8;
const MIN_GAP_MM = 4;
const HEADER_Y_MM = 3.2;
const TEXT_PAD_X_MM = 3;
const TEXT_TOP_MM = 2.2;
const TEXT_HEIGHT_MM = 8;
const BARCODE_PAD_X_MM = 5;
const BARCODE_TOP_MM = 12.5;
const BARCODE_HEIGHT_MM = 16;
export const LOCATION_CODE_MESSAGE = "库位码要像 A1 或 A9-1。整面不用写层和位。";
function blank(value) {
    if (typeof value !== "string")
        return null;
    const trimmed = value.trim();
    return trimmed.length > 0 ? trimmed : null;
}
function slotsAcross(spanMm, itemMm, minGapMm) {
    if (spanMm < itemMm)
        return 0;
    return Math.floor((spanMm + minGapMm) / (itemMm + minGapMm));
}
export function locationSheetLayout() {
    const innerWidth = PAGE_WIDTH_MM - MARGIN_X_MM * 2;
    const innerHeight = PAGE_HEIGHT_MM - MARGIN_TOP_MM - MARGIN_BOTTOM_MM;
    const columns = slotsAcross(innerWidth, LABEL_WIDTH_MM, MIN_GAP_MM);
    const rows = slotsAcross(innerHeight, LABEL_HEIGHT_MM, MIN_GAP_MM);
    const gapXMm = columns > 1 ? (innerWidth - columns * LABEL_WIDTH_MM) / (columns - 1) : 0;
    const gapYMm = rows > 1 ? (innerHeight - rows * LABEL_HEIGHT_MM) / (rows - 1) : 0;
    const slots = [];
    for (let row = 0; row < rows; row += 1) {
        for (let column = 0; column < columns; column += 1) {
            slots.push({
                xMm: MARGIN_X_MM + column * (LABEL_WIDTH_MM + gapXMm),
                yMm: MARGIN_TOP_MM + row * (LABEL_HEIGHT_MM + gapYMm),
            });
        }
    }
    return {
        pageWidthMm: PAGE_WIDTH_MM,
        pageHeightMm: PAGE_HEIGHT_MM,
        marginXMm: MARGIN_X_MM,
        marginTopMm: MARGIN_TOP_MM,
        marginBottomMm: MARGIN_BOTTOM_MM,
        gapXMm,
        gapYMm,
        labelWidthMm: LABEL_WIDTH_MM,
        labelHeightMm: LABEL_HEIGHT_MM,
        columns,
        rows,
        perPage: columns * rows,
        headerYMm: HEADER_Y_MM,
        slots,
    };
}
export function locationLabelContent(slot) {
    return {
        textXMm: slot.xMm + TEXT_PAD_X_MM,
        textYMm: slot.yMm + TEXT_TOP_MM,
        textWidthMm: LABEL_WIDTH_MM - TEXT_PAD_X_MM * 2,
        textHeightMm: TEXT_HEIGHT_MM,
        barcodeXMm: slot.xMm + BARCODE_PAD_X_MM,
        barcodeYMm: slot.yMm + BARCODE_TOP_MM,
        barcodeWidthMm: LABEL_WIDTH_MM - BARCODE_PAD_X_MM * 2,
        barcodeHeightMm: BARCODE_HEIGHT_MM,
    };
}
export function locationSheetPages(count, perPage) {
    if (count <= 0 || perPage <= 0)
        return 0;
    return Math.ceil(count / perPage);
}
const LOCATION_CODE_INPUT = /^([A-Z])0*([1-9]\d?)(?:-0*([1-9]\d?))?(?:-0*([1-9]\d?))?$/;
function pad2(value) {
    return String(value).padStart(2, "0");
}
function unpadded(value) {
    return String(Number(value));
}
export function formatLocationCode(input) {
    const zone = input.zone.trim().toUpperCase();
    let code = `${zone}${input.rack}`;
    if (input.shelf != null)
        code += `-${input.shelf}`;
    if (input.bin != null)
        code += `-${input.bin}`;
    return code;
}
export function parseLocationCode(raw) {
    const trimmed = raw.trim().toUpperCase();
    if (trimmed.startsWith("-") || /^[A-Z]-/.test(trimmed))
        return null;
    const match = trimmed.match(LOCATION_CODE_INPUT);
    if (!match?.[1] || !match[2])
        return null;
    const rack = Number(match[2]);
    const shelf = match[3] === undefined ? null : Number(match[3]);
    const bin = match[4] === undefined ? null : Number(match[4]);
    if (rack > 99 || (shelf !== null && shelf > 99) || (bin !== null && bin > 99))
        return null;
    return {
        code: formatLocationCode({ zone: match[1], rack, shelf, bin }),
        zone: match[1],
        rack: pad2(rack),
        shelf: shelf === null ? "" : pad2(shelf),
        bin: bin === null ? "" : pad2(bin),
    };
}
/**
 * 仓库走路顺序：先比架号（数字，10 在 8 后面），同一节的 A 面整段在 B 面前面。
 * 同一面上整面在分层前面，再比层号，最后比位号。
 */
export function compareLocationCodes(left, right) {
    const a = parseLocationCode(left);
    const b = parseLocationCode(right);
    if (!a || !b)
        return left < right ? -1 : left > right ? 1 : 0;
    const rack = Number(a.rack) - Number(b.rack);
    if (rack !== 0)
        return rack;
    const zone = a.zone.localeCompare(b.zone);
    if (zone !== 0)
        return zone;
    const shelf = Number(a.shelf || 0) - Number(b.shelf || 0);
    if (shelf !== 0)
        return shelf;
    return Number(a.bin || 0) - Number(b.bin || 0);
}
export function locationOverlapMessage(incoming, occupants) {
    for (const other of occupants) {
        if (other.code === incoming.code)
            continue;
        if (other.zone !== incoming.zone || other.rack !== incoming.rack)
            continue;
        const incomingWhole = incoming.shelf === "";
        const otherWhole = other.shelf === "";
        if (incomingWhole && !otherWhole) {
            return `这一面已经按层分开了。要改成整面一个库位，先删掉 ${other.code}。`;
        }
        if (!incomingWhole && otherWhole) {
            return `${other.code} 已经代表这一整面。要按层建库位，先删掉 ${other.code}。`;
        }
        if (incoming.shelf !== other.shelf)
            continue;
        const incomingOpen = incoming.bin === "";
        const otherOpen = other.bin === "";
        if (incomingOpen && !otherOpen) {
            return `这一层已经分成了格。要改成整层一个库位，先删掉 ${other.code}。`;
        }
        if (!incomingOpen && otherOpen) {
            return `${other.code} 已经代表这一整层。要再分格，先删掉 ${other.code}。`;
        }
    }
    return null;
}
export function sortLocationCodes(codes) {
    return [...codes].sort(compareLocationCodes);
}
export function codeInRange(code, range) {
    const parsed = parseLocationCode(code);
    if (!parsed)
        return false;
    if (range.zone && parsed.zone !== range.zone)
        return false;
    if (range.rack && parsed.rack !== range.rack)
        return false;
    if (range.shelf && parsed.shelf !== range.shelf)
        return false;
    return true;
}
export function codesInRange(codes, range) {
    return sortLocationCodes(codes.filter((code) => codeInRange(code, range)));
}
export function locationRangeText(range) {
    if (!range.zone)
        return "全部";
    const rack = range.rack ? unpadded(range.rack) : "";
    const shelf = range.shelf ? `-${unpadded(range.shelf)}` : "";
    return `${range.zone}${rack}${shelf}`;
}
export function locationSheetCaption(range, page, pages) {
    const parts = [];
    if (range.zone)
        parts.push(`面 ${range.zone}`);
    else
        parts.push("全部");
    if (range.rack)
        parts.push(`架 ${unpadded(range.rack)}`);
    if (range.shelf)
        parts.push(`层 ${unpadded(range.shelf)}`);
    parts.push(`第 ${page} 张，共 ${pages} 张`);
    return parts.join(" · ");
}
export function locationBatchBlock(count, range) {
    if (count <= 0)
        return "这个范围还没有库位。换一个面或架。";
    if (count <= LOCATION_BATCH_LIMIT)
        return null;
    if (!range.zone)
        return "请先定一个面";
    if (!range.rack)
        return "请再定一架";
    if (!range.shelf)
        return "请再定一层";
    return `这一层有 ${count} 个库位，一次贴不完。`;
}
export function previewLocationBatch(count, range) {
    const perPage = locationSheetLayout().perPage;
    const active = range ?? { zone: null, rack: null, shelf: null };
    const block = locationBatchBlock(count, active);
    if (count <= 0) {
        return {
            status: "empty",
            message: block ?? "这个范围还没有库位。换一个面或架。",
            count,
            perPage,
            sheets: 0,
        };
    }
    if (block) {
        return { status: "too-many", message: block, count, perPage, sheets: 0 };
    }
    const sheets = locationSheetPages(count, perPage);
    return {
        status: "ready",
        message: `这个范围有 ${count} 个库位。每张纸排 ${perPage} 个，共 ${sheets} 张。`,
        count,
        perPage,
        sheets,
    };
}
export function readLocationLabelQuery(input) {
    const zone = blank(input.zone);
    const rack = blank(input.rack);
    const shelf = blank(input.shelf);
    if (zone && !/^[A-Z]$/.test(zone))
        return { ok: false, message: "面要是一位大写字母，例如 A。" };
    if (rack && !zone)
        return { ok: false, message: "先选定一个面，再选架。" };
    if (rack && !/^\d{2}$/.test(rack))
        return { ok: false, message: "架要是两位数字，例如 02。" };
    if (shelf && !rack)
        return { ok: false, message: "先选定一个架，再选层。" };
    if (shelf && !/^\d{2}$/.test(shelf))
        return { ok: false, message: "层要是两位数字，例如 03。" };
    return { ok: true, range: { zone, rack, shelf } };
}
function inSpan(value) {
    return Number.isInteger(value) && value >= 1 && value <= 99;
}
function optionalNumbers(from, to, label) {
    if (from === null && to === null)
        return { values: null, message: null };
    if (from === null || to === null)
        return { values: null, message: `${label}的起号和止号要一起填。` };
    if (!inSpan(from) || !inSpan(to))
        return { values: null, message: `${label}要是 1 到 99。` };
    if (from > to)
        return { values: null, message: "起号不能大于止号。请把止号改成不小于起号。" };
    const values = [];
    for (let value = from; value <= to; value += 1)
        values.push(value);
    return { values, message: null };
}
export function locationGenerateIssue(span) {
    if (!/^[A-Z]$/.test(span.zone))
        return "面要是一位大写字母，例如 A。";
    if (!inSpan(span.rackFrom) || !inSpan(span.rackTo))
        return "架要是 1 到 99。";
    if (span.rackFrom > span.rackTo)
        return "起号不能大于止号。请把止号改成不小于起号。";
    const shelves = optionalNumbers(span.shelfFrom, span.shelfTo, "层");
    if (shelves.message)
        return shelves.message;
    const bins = optionalNumbers(span.binFrom, span.binTo, "位");
    if (bins.message)
        return bins.message;
    if (bins.values && !shelves.values)
        return "请先填写层，再填写位。";
    return null;
}
export function locationGenerateTotal(span) {
    const racks = span.rackTo - span.rackFrom + 1;
    const shelves = span.shelfFrom === null || span.shelfTo === null ? 1 : span.shelfTo - span.shelfFrom + 1;
    const bins = span.binFrom === null || span.binTo === null ? 1 : span.binTo - span.binFrom + 1;
    return racks * shelves * bins;
}
export function locationGenerateCodes(span) {
    const shelves = optionalNumbers(span.shelfFrom, span.shelfTo, "层").values;
    const bins = optionalNumbers(span.binFrom, span.binTo, "位").values;
    const codes = [];
    for (let rack = span.rackFrom; rack <= span.rackTo; rack += 1) {
        const shelfValues = shelves ?? [null];
        for (const shelf of shelfValues) {
            const binValues = bins ?? [null];
            for (const bin of binValues) {
                codes.push(formatLocationCode({ zone: span.zone, rack, shelf, bin }));
            }
        }
    }
    return codes;
}
export function locationGenerateTooMany(total) {
    if (total <= LOCATION_MASTER_LIMIT)
        return null;
    return `这一次会有 ${total} 个库位，一次最多生成 ${LOCATION_MASTER_LIMIT} 个。请把起止号收短。`;
}
export function locationGeneratePlanText(created, skipped) {
    return `将新建 ${created} 个库位，跳过 ${skipped} 个已经有的。`;
}
export function locationImportTooMany(rows) {
    if (rows <= LOCATION_MASTER_LIMIT)
        return null;
    return `这份清单有 ${rows} 行，一次最多导入 ${LOCATION_MASTER_LIMIT} 行。请把清单拆短后再导入。`;
}
export function locationBatchTooMany(count) {
    if (count <= LOCATION_MASTER_LIMIT)
        return null;
    return `这一批有 ${count} 个库位，一次最多改 ${LOCATION_MASTER_LIMIT} 个。请先把范围收窄。`;
}
export function locationDeleteTooMany(empty) {
    if (empty <= LOCATION_MASTER_LIMIT)
        return null;
    return `这一批有 ${empty} 个空库位，一次最多删除 ${LOCATION_MASTER_LIMIT} 个。请先把范围收窄。`;
}
export function locationDeletePlanText(empty, kept) {
    return `这批有 ${empty} 个空库位可以删除。${kept} 个上面有鞋，会留下。`;
}
//# sourceMappingURL=location-labels.js.map